import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modifyStoreConnection: {
    defaultMessage: 'Modify Store Connection',
    description: 'Hyperlink text. This click sends the user to a place where they can modify their store connection settings.',
    id: 'e3d3HO',
  },
  contactSupport: {
    defaultMessage: 'Contact Support',
    description: 'Button text. This click sends the user to contact support for help with store errors.',
    id: 'SJebPU',
  },
  getHelp: {
    defaultMessage: 'Get Help',
    description: 'Button text. This click sends the user to help documentation for store errors.',
    id: 'Cb0Hbc',
  },
  copyErrorData: {
    defaultMessage: 'Copy Error Data',
    description: 'Button text. This click copies the raw error message to clipboard.',
    id: 'jRHNVN',
  },
  troubleshootingTitle: {
    defaultMessage: 'Please troubleshoot with the following steps:',
    description: 'Title for troubleshooting steps section in store error modal.',
    id: 'u+ATgP',
  },
  troubleshootingStep1: {
    defaultMessage: 'Attempt to reconfigure your store connection.',
    description: 'First troubleshooting step for store errors.',
    id: '2VGkfl',
  },
  troubleshootingStep2: {
    defaultMessage: 'Get help with store errors.',
    description: 'Second troubleshooting step for store errors.',
    id: 's57frj',
  },
  troubleshootingStep3: {
    defaultMessage: 'Contact support for more help.',
    description: 'Third troubleshooting step for store errors.',
    id: 'Dh+gEd',
  },
  reconfigureStoreConnection: {
    defaultMessage: 'Reconfigure Store Connection',
    description: 'Button text. This click sends the user to reconfigure their store connection.',
    id: '1uerBM',
  },
  storeErrorTitle: {
    defaultMessage: 'Store Error',
    description: 'Modal title for store error modal.',
    id: 't8mpW/',
  },
  getHelpWithStoreErrorsLink: {
    defaultMessage: 'Get Help with Store Errors',
    id: 'GMjTlr',
    description: 'Hyperlink text. Sends user to a help article about errors with their store. A store is a place users sell goods.',
  },
  etsyUnauthorizedError: {
    description: 'Error message for when a user tries to connect to Etsy but their credentials are incorrect and the error is 401.',
    defaultMessage: '401 Unauthorized: Username or login information is incorrect. <a>Learn how to resolve this error</a>.',
    id: 'jJfprr',
  },
  etsyReconfigureYourConnectionError: {
    description: 'Error message for when a user tries to connect to Etsy but their credentials are incorrect.',
    defaultMessage: 'Username or login information is incorrect. <a>Learn how to resolve this error</a>.',
    id: 'vxN63p',
  },
  ebayReconfigureYourConnectionError: {
    description: 'Error message for when a user tries to connect to eBay but their credentials are incorrect.',
    defaultMessage: 'Reconfigure your eBay connection. <a>Learn how to reconfigure</a>.',
    id: '56wLVb',
  },
  amazonReconfigureYourConnectioneError: {
    description: 'Error message for when a user tries to connect to Amazon but their credentials are incorrect.',
    defaultMessage: 'Reconfigure your Amazon connection. <a>Learn how to reconfigure</a>.',
    id: 'xyTIC2',
  },
  allStoresForbiddenError: {
    description: 'Error message for when a user tries to connect to a store but the connection is 403: Forbidden.',
    defaultMessage: '403 Forbidden: <a>Learn more about this error</a>.',
    id: 'Z5aRll',
  },
  allStoresShipStationStatusError: {
    description: 'Error message for when a user tries to connect to a store but there are errors',
    defaultMessage:
      "We're having trouble connecting to this store. Visit their website or check <a>ShipStation's Status Page</a> to see if any issues have been reported.",
    id: '8/P14e',
  },
  allStoresReconfigureYourConnectionError: {
    description: 'Error message for when a user tries to connect to a store but a 400: Bad request was returned.',
    defaultMessage: '400 Bad Request: You may need to reconfigure your store connection. <a>Learn how to reconfigure</a>.',
    id: 'W5HbK/',
  },
  allStoresSystemCapacityError: {
    description: 'Error message for when a user tries to connect to a store but could not parse response with status code: 429 from URL',
    defaultMessage:
      'This marketplace will not allow an order refresh at this time. Please <a>reconfigure</a> your store connection. You may need to wait up to 1 hour before manually refreshing orders again.',
    id: 'jdyZlt',
  },
});
